<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin"></i> Loading
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="Update Attribute">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
    <attributes-list-form
      :attribute="attribute"
      @submit="submit"
    ></attributes-list-form>
  </div>
</template>

<script>
import Vue from "vue";
import AttributesListForm from "@/components/lab/attributeslists/AttributesListForm";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import VueNotifications from "vue-notifications";
import AttributeListModel from "@/models/lab/AttributeListModel";
import { attributesListsNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { mapGetters } from "vuex";

const attributeListsRepository = LabRepositoryFactory.get("attributeLists");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "AttributesListsEdit",
  components: {
    AttributesListForm,
    BasicHeading,
    HeaderButtonGroup,
  },
  computed: {
    ...mapGetters({ parent: "parentId" }),
    id() {
      return this.$route.params.id;
    },
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/managed-lists",
            title: "Managed lists",
          },
        ],
      };
    },
  },
  data() {
    return {
      loading: true,
      attribute: null,
    };
  },
  methods: {
    submit(payload) {
      const { value, managed_list_id, parent_id } = payload;
      return attributeListsRepository
        .update(this.id, { value, managed_list_id, parent_id })
        .then((response) => {
          if (response && response.status === 200 && response.data) {
            this.editSuccess();
            this.$router.push(`/managed-lists/${this.parent}`);
          } else {
            this.editFail();
          }
        })
        .catch(() => {
          this.editFail();
        });
    },
    async init() {
      await this.fetch();
    },
    fetch() {
      const fetches = [];
      const attribute_model = new AttributeListModel({ id: this.id });
      fetches.push(
        attribute_model.fetch().then(({ response }) => {
          if (response && response.status === 200 && response.data) {
            this.attribute = response.data;
          }
        })
      );
      return Promise.all(fetches);
    },
  },
  mounted() {
    this.loading = true;
    this.init().then(() => {
      this.loading = false;
    });
  },
  notifications: attributesListsNotifications,
};
</script>
